import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { BsArrowUp, BsArrowDown, BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import { MdRunCircle } from 'react-icons/md';

//Setting up animation options for each element beforehand
const blackBox = {
	initial: {
		x: '0%',
	},
	animate: {
		x: '100%',
		transition: {
			when: 'afterChildren',
			duration: 0.55,
			ease: [1, -0.03, 0.71, 1.02],
		},
	},
};

const tip = {
	initial: {
		opacity: 1,
	},
	animate: {
		opacity: 0,
		transition: {
			delay: 1,
			duration: 0.8,
			ease: [1, -0.03, 0.71, 1.02],
		},
	},
};

export const PageTransition = () => {
	const backdrop = useRef(null);

	return (
		<>
			{/* Adding the black backdrop, the text-svg with fill effect and arrow keys to the page transition
    using onAnimationStart and onAnimationComplete to hide and show the component */}
			<motion.div
				ref={backdrop}
				className="page-transition-container"
				initial="initial"
				animate="animate"
				variants={blackBox}
				onAnimationStart={() => backdrop.current.classList.add('animate')}
				onAnimationComplete={() => backdrop.current.classList.remove('animate')}
			>
				<div className="page-transition-text-wrapper">
					<span className="page-transition-text-title" data-text="Spring Studio">
						Spring Studio
					</span>
				</div>
				<motion.div variants={tip} className="page-transition-arrow-keys">
					<div className="page-transition-arrow-keys-row">
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
						<span className="page-transition-arrow-key">
							<MdRunCircle />
						</span>
					</div>

					{/* <div className="page-transition-arrow-keys-title">Tip:</div> */}
					{/* <div className="page-transition-arrow-keys-row">
						<BsArrowUp className="page-transition-arrow-key-up" />
					</div>
					<div className="page-transition-arrow-keys-row">
						<BsArrowLeft className="page-transition-arrow-key" />
						<BsArrowDown className="page-transition-arrow-key" />
						<BsArrowRight className="page-transition-arrow-key" />
					</div> */}
				</motion.div>
			</motion.div>
		</>
	);
};
